// extracted by mini-css-extract-plugin
export var container = "_h8-0";
export var content = "_h8-3";
export var customerTitle = "_h8-4";
export var empty = "_h8-5";
export var gray = "_h8-6";
export var header = "_h8-7";
export var info = "_h8-8";
export var loading = "_h8-2";
export var loadingCard = "_h8-9";
export var oneLine = "_h8-a";
export var personName = "_h8-e";
export var pillContainer = "_h8-b";
export var selected = "_h8-1";
export var text = "_h8-c";
export var twoLines = "_h8-d";
export var unread = "_h8-f";
export var unreadIndicator = "_h8-g";